import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { Icon, IconButton, ButtonGroup, Tooltip, Typography } from '@mui/material';

import MDAvatar from "dashboard/components/MDAvatar";
import MDInput from "dashboard/components/MDInput";
import MDTypography from "dashboard/components/MDTypography";
import MDButton from "dashboard/components/MDButton";
import MDBox from "dashboard/components/MDBox";
import loader from "assets/images/shapes/loader.svg";

const CartList = (props) => {

  const {cart, productList, addItem, removeItem, isLoading, link } = props;

  return (
    <TableContainer component={Paper}>
    {isLoading && <MDAvatar display="flex" sx={{padding: 0,position: "absolute",zIndex: 9,top: "50%",left: "50%",transform: "translate3d(-24px, -20px, 0)"}}  
                    src={loader} alt="Avatar" variant="square" size="md" />}
     <Table sx={{ minWidth: "100%" }} aria-label="caption table">
        <caption><MDTypography variant="caption">Click on the name of the product to modify the order</MDTypography></caption>
        <TableBody>
          <TableRow>
            <TableCell align="center" sx={{color:'text.main'}} colSpan={3}>product</TableCell>
            <TableCell align="center" sx={{color:'text.main'}}>Quantity</TableCell>
            <TableCell align="center" sx={{color:'text.main'}}>-</TableCell>
          </TableRow> 
          {productList.map( product => (
            <TableRow key={product.id}>
              <TableCell scope="row">
              <MDAvatar variant="rounded" sx={{width:"120px", height:"75px", objectFit:"cover"}} imgType="product" src={`${process.env.REACT_APP_PUBLIC_URL}/img/product/${product.selectedImage}`} alt={product.productName} size="lg"  />
              </TableCell>
              <TableCell align="center">
                <Tooltip title="Modify this line" placement="top" arrow>
                  <MDButton  component={link} to={`/product/${product.id}`}>{product.productName}</MDButton>
                </Tooltip>
              </TableCell>
              <TableCell align="center"><Typography variant="body2" color="primary">{product.price.sold === 0 ? product.priceShow.original : product.priceShow.sold}</Typography></TableCell>
              <TableCell align="center">
                <MDBox my={2}>
                  <ButtonGroup
                    disableElevation
                    aria-label="Disabled elevation buttons"
                  >
                  <MDButton onClick={()=> removeItem({id:product.id, quantity:1})} disableElevation size="small" sx={{p:1}} variant="gradient" color="secondary">
                    <Icon sx={{mx:"auto"}} fontSize="lg">remove</Icon>
                  </MDButton>
                      <MDInput value={cart.items?.find(item => item.id === product.id)?.quantity} type="text"
                      size="small"
                      className="quantity-details"
                      />
                  <MDButton onClick={()=>addItem({id:product.id, quantity:1})} disableElevation sx={{p:1}} size="small" variant="gradient" color="secondary">
                    <Icon sx={{mx:"auto"}} fontSize="lg">add</Icon>
                  </MDButton>
                  </ButtonGroup>
                </MDBox>
              </TableCell>
              <TableCell align="center">
                <IconButton onClick={()=>removeItem({id:product.id, quantity:0})} 
                      sx={{p:.5,m:0,backgroundColor:"rgba(0, 0, 0, 0.2)" }}
                      size="medium"
                      color="secondary"
                      >
                  <Icon sx={{mx:"auto"}} fontSize="small">delete_outlined</Icon>
                </IconButton>  </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
  </TableContainer>
  )
}

export default CartList